@if (!shell.fullPage && showBetaBanner) {
  <ui-beta-banner (revertClicked)="revertToClassic()" />
}

<div class="modern-shell" [class.modern-shell--full-page]="shell.fullPage">
  @if (!shell.fullPage) {
    <div class="modern-shell__sidebar-wrap">
      <ui-sidebar
        class="modern-shell__sidebar-desktop"
        [name]="shell.associacaoNameSig()"
        [logoUrl]="shell.associacaoLogo"
        [loading]="shell.isLoading"
        [currentUrl]="routerUrl"
        [version]="shell.appVersion"
        [collapsed]="shell.modernSidebarCollapsed()"
        (itemActivated)="closeDrawer()"
        (collapseToggle)="shell.toggleModernSidebarCollapse()"
      />
    </div>

    <ui-drawer
      [visible]="shell.drawerVisible"
      title="Menu"
      (onClose)="closeDrawer()">
      <ui-sidebar
        [drawer]="true"
        [showFooter]="false"
        [name]="shell.associacaoNameSig()"
        [logoUrl]="shell.associacaoLogo"
        [loading]="shell.isLoading"
        [currentUrl]="routerUrl"
        (itemActivated)="closeDrawer()"
      />
    </ui-drawer>
  }

  <div class="modern-main">
    @if (!shell.fullPage) {
      <ui-topbar
        [breadcrumbs]="breadcrumbs"
        [showSidebarCollapse]="true"
        [sidebarCollapsed]="shell.modernSidebarCollapsed()"
        (menuClick)="shell.toggleMenu()"
        (sidebarCollapseClick)="shell.toggleModernSidebarCollapse()"
      >
        <ui-nav-search search />
        <ui-theme-toggle actions />
        <ui-user-menu actions />
      </ui-topbar>
    }

    <main class="modern-content" [class.modern-content--full-page]="shell.fullPage">
      @if (shell.isLoading && !shell.fullPage) {
        <ui-skeleton [rows]="8" />
      } @else {
        <router-outlet />
      }
    </main>

    @if (!shell.fullPage) {
      <ui-app-footer [version]="shell.appVersion" [year]="shell.date.getFullYear()" />
    }
  </div>
</div>
